import axios from 'axios';

export const API_ROOT_URL = 'https://api.adba.in';
// export const API_ROOT_URL = 'http://127.0.0.1:5019';
// export const API_ROOT_URL = 'https://api.adba.ashtamtechnologies.com';
export const API_BASE_URL = `${API_ROOT_URL}/api`;


export const EMAIL_ROOT_URL = "https://api.ashtamtechnologies.com/api";
export const EMAIL_BASE_URL = `${EMAIL_ROOT_URL}/api`;


export const emailApi = axios.create({
  baseURL: EMAIL_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});


// Create a professional Axios instance
export const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add request interceptor to automatically attach authorization bearer tokens
api.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor to handle token expiration (401 Unauthorized)
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      const isLoginRequest = error.config && error.config.url && error.config.url.includes('/Auth/login');
      if (!isLoginRequest) {
        // Clear authorization details from storage
        sessionStorage.removeItem('token');
        sessionStorage.removeItem('accountId');
        sessionStorage.removeItem('mobileNumber');
        sessionStorage.removeItem('registered_player');
        sessionStorage.removeItem('selectedPlayerId');

        // Redirect user to the login screen
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);


/* ============================================================
   PLAYER REGISTRATION ENDPOINTS
   ============================================================ */

/**
 * Create a new player (affiliation registration)
 * @param {Object} playerData - Player details (camelCase)
 * @returns {Promise} Axios response containing created player with playerId
 */
export const createPlayer = (playerData) => {
  return api.post('/Player/create', playerData);
};

/**
 * Upload profile photo for a player
 * @param {string} playerId - UUID of the player
 * @param {File} photoFile - Image file (JPG/PNG)
 * @returns {Promise} Axios response
 */
export const uploadPlayerPhoto = (playerId, photoFile) => {
  const formData = new FormData();
  formData.append('file', photoFile);
  return api.post(`/Player/upload-photo/${playerId}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

/**
 * Upload age proof document for a player
 * @param {string} playerId - UUID of the player
 * @param {File} ageProofFile - PDF or image file
 * @returns {Promise} Axios response
 */
export const uploadAgeProof = (playerId, ageProofFile) => {
  const formData = new FormData();
  formData.append('file', ageProofFile);
  return api.post(`/Player/upload-age-proof/${playerId}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};


/**
 * Register membership for a player
 * @param {string} playerId - UUID of the player
 * @param {number} seasonId - Season ID (e.g., 1)
 * @returns {Promise} Axios response
 */
export const registerMembership = (playerId, seasonId) => {
  return api.post('/Player/register-membership', { playerId, seasonId });
};




// Email INtegration

export const sendEmail = (emailDate) => {
  return emailApi.post('/Email/send', emailDate);
};

/**
 * Change user account password
 * @param {string} currentPassword
 * @param {string} newPassword
 * @returns {Promise} Axios response
 */
export const changePassword = (currentPassword, newPassword) => {
  return api.post('/Auth/change-password', { currentPassword, newPassword });
};